const adminImportPageInitialState = {
  fetchingEntities: false,
  savingEntity: false,
  removingEntity: false,
  uploadingEntities: false,
  importingEntities: false,
  entities: [],
  uploadedEntities: [],
};

export default adminImportPageInitialState;
